module.exports = __webpack_public_path__ + "static/media/close-gray.4b7e84c5.svg";